
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const EditWidowDaughter = () => {
    const navigate = useNavigate();
    const [profileImage, setProfileImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    const initialValues = {
        profileImage: null,
        વિધવા_દીકરીનું_નામ: '',
        તારીખ: '',
        પતિના_મૃત્યુની_તારીખ: '',
        મોબાઈલ_નંબર: '',
        હાલમાં_પરિવારના_સભ્યની_સંખ્યા: '',
        દીકરા: '',
        દીકરી: '',
        રહેઠાણનું_હાલનું_સરનામું: '',
        ઘરની_આર્થિક_પરિસ્થિતિ: '',
        સરનામું: '',
        તાલુકો: '',
        જિલ્લો: '',
        પિયરનું_ગામ: '',
        પિયરની_વિગત: '',
        જમીન: '',
        મકાન: '',
        અન્ય: '',
        અન્ય_કોઈ_ટ્રસ્ટ_મારફત_સહાય: '',
        ટ્રસ્ટ_કે_મંડળની_વિગત: '',
    };

    const validationSchema = Yup.object({
        // વિધવા_દીકરીનું_નામ: Yup.string().required('Required'),
        // તારીખ: Yup.string().required('Required'),
        // સભ્યના_પિતા_નું_નામ: Yup.string().required('Required'),
        // માધ્યમ: Yup.string().required('Required'),
        // સભ્યનું_ભણતર: Yup.string().required('Required'),
        // ટકાવારી: Yup.string().required('Required'),
        // મેળવેલ_ગુણ: Yup.string().required('Required'),
    });

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setProfileImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };
    const acceptRequest = () => {
        console.log('Accept Request');
    }
    const rejectRequest = () => {
        console.log('Reject Request');
    }
    return (
        <>
            <div className="bg-gray-50">
                <div className=" mx-aut0">
                    <div className="bg-white rounded-lg shadow p-9">
                        <div className="py-2 lg:py-4 flex flex-wrap items-center">
                            <button
                                onClick={() => navigate(-1)}
                                className="flex items-center text-gray_2"
                            >
                                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                                </svg>
                                Back
                            </button>
                        </div>
                        <div className="flex flex-wrap justify-between items-center pb-6 xl:space-y-0 space-y-3">
                            <div className="flex items-center space-x-4">
                                <div className="h-12 lg:h-16 w-12 lg:w-16 rounded-full bg-gray-200 flex items-center justify-center text-xs text-gray-500 border border-gray-300">
                                    No Image
                                </div>
                                <div className="flex flex-col">
                                    <h2 className="text-16 lg:text-24 font-semibold text-text_1">
                                        Emilia Isobel Euphemia Rose Clarke
                                        <span className="text-14 text-green bg-[#E7FAF0] rounded-lg py-1 lg:py-2 px-2.5 lg:px-4 ml-5">Active</span>
                                    </h2>
                                    <span className="block text-sm text-gray-500">+91 9632597041</span>
                                </div>
                            </div>

                            <div className="flex space-x-3">
                                <button
                                    onClick={() => { acceptRequest() }}
                                    className="btn"
                                >
                                    Accept
                                </button>
                                <button
                                    onClick={() => { rejectRequest() }}
                                    className="px-4 py-2 bg-red hover:bg-white hover:text-red border hover:border-red text-white font-medium rounded-md anim"
                                >
                                    Reject
                                </button>
                            </div>
                        </div>
                        <div className="shadow-custom_shadow rounded-[20px] p-9">
                            <h2 className="text-18 font-semibold text-gray_2 border-b border-gray_2 pb-6">Details of widow daughter
                                <span className="text-14 text-green bg-[#E7FAF0] rounded-lg py-2 px-4 ml-5">Active</span>
                            </h2>
                            <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                            >
                                {({ isSubmitting, setFieldValue }) => (
                                    <Form className='pt-6'>
                                        <div className="flex flex-wrap -mx-3">
                                            <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    વિધવા દીકરીનું નામ
                                                </label>
                                                <Field
                                                    name="વિધવા_દીકરીનું_નામ"
                                                    className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                    placeholder='વિધવા દીકરીનું નામ'
                                                />
                                                {/* <ErrorMessage name="સભ્યનુ_અટક" component="div" className="text-red-500 text-sm mt-1" /> */}
                                            </div>

                                            <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    તારીખ
                                                </label>
                                                <Field
                                                    type="date"
                                                    name="તારીખ"
                                                    className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                    placeholder='તારીખ'
                                                />
                                                {/* <ErrorMessage name="સભ્યનું_નામ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                            </div>

                                            <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    પતિના મૃત્યુની તારીખ
                                                </label>
                                                <Field
                                                    name="પતિના_મૃત્યુની_તારીખ"
                                                    className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                    placeholder='પતિના મૃત્યુની તારીખ'
                                                />
                                                {/* <ErrorMessage name="સભ્યના_પિતા_નું_નામ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                            </div>

                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    મોબાઈલ નંબર
                                                </label>
                                                <div className='flag_drop input_phone'>
                                                    <PhoneInput
                                                        country={'in'}
                                                        value=""
                                                        onChange={phone => setFieldValue('મોબાઈલ_નંબર', phone)}
                                                        inputClass="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder='મોબાઈલ નંબર'
                                                    />
                                                </div>
                                                {/* <ErrorMessage name="મોબાઈલ_નંબર" component="div" className="text-red text-sm mt-1" /> */}
                                            </div>
                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    હાલમાં પરિવારના સભ્યની સંખ્યા
                                                </label>
                                                <Field
                                                    name="હાલમાં_પરિવારના_સભ્યની_સંખ્યા"
                                                    className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                    placeholder="હાલમાં પરિવારના સભ્યની સંખ્યા"
                                                />
                                                {/* <ErrorMessage name="મેળવેલ_ગુણ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                            </div>
                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    આપણા બાળકોની વિગત
                                                </label>
                                                <div className="flex justify-center space-x-2">
                                                    <Field
                                                        name="૨_દીકરા"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder="૨ દીકરા"
                                                    />
                                                    <Field
                                                        name="૧_દીકરી"
                                                        className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder="૧ દીકરી"
                                                    />
                                                </div>
                                                {/* <ErrorMessage name="મેળવેલ_ગુણ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                            </div>
                                            <div className="w-full px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    રહેઠાણનું હાલનું સરનામું
                                                </label>
                                                <Field
                                                    name="રહેઠાણનુ_હાલનું_સરનામું"
                                                    className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                    placeholder="રહેઠાણનું હાલનું સરનામું"
                                                />
                                                {/* <ErrorMessage name="ટકાવારી" component="div" className="text-red-500 text-sm mt-1" /> */}
                                            </div>
                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    ઘરની આર્થિક પરિસ્થિતિને કયા સ્ત્રોત દ્વારા મદદ મળે છે?
                                                </label>
                                                <Field
                                                    name="ઘરની_આર્થિક_પરિસ્થિતિ"
                                                    className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                    placeholder="ઘરની આર્થિક પરિસ્થિતિને કયા સ્ત્રોત દ્વારા મદદ મળે છે?"
                                                />
                                                {/* <ErrorMessage name="મેળવેલ_ગુણ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                            </div>
                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    મૂળવતનનું સરનામું ગામ
                                                </label>
                                                <Field
                                                    as="select"
                                                    name="સરનામું"
                                                    className="w-full p-2 border border-gray-300 rounded-md"
                                                    placeholder='મૂળવતનનું સરનામું ગામ'
                                                >
                                                    <option value="">મૂળવતનનું સરનામું ગામ</option>
                                                    <option value="સરનામું">સરનામું</option>
                                                    <option value="સરનામું">સરનામું</option>
                                                    <option value="સરનામું">સરનામું</option>
                                                </Field>
                                            </div>
                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    તાલુકો
                                                </label>
                                                <Field
                                                    as="select"
                                                    name="તાલુકો"
                                                    className="w-full p-2 border border-gray-300 rounded-md"
                                                    placeholder='તાલુકો'
                                                >
                                                    <option value="">તાલુકો</option>
                                                    <option value="તાલુકો">તાલુકો</option>
                                                    <option value="તાલુકો">તાલુકો</option>
                                                    <option value="તાલુકો">તાલુકો</option>
                                                </Field>
                                            </div>
                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    જિલ્લો
                                                </label>
                                                <Field
                                                    as="select"
                                                    name="જિલ્લો"
                                                    className="w-full p-2 border border-gray-300 rounded-md"
                                                    placeholder='જિલ્લો'
                                                >
                                                    <option value="">જિલ્લો</option>
                                                    <option value="જિલ્લો">જિલ્લો</option>
                                                    <option value="જિલ્લો">જિલ્લો</option>
                                                    <option value="જિલ્લો">જિલ્લો</option>
                                                </Field>
                                            </div>
                                            <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    પિયરની વિગત/ પિતાશ્રીનું નામ
                                                </label>
                                                <Field
                                                    name=" પિયરની_વિગત"
                                                    className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                    placeholder='પિયરની વિગત/ પિતાશ્રીનું નામ'
                                                />
                                                {/* <ErrorMessage name="સભ્યનુ_અટક" component="div" className="text-red-500 text-sm mt-1" /> */}
                                            </div>
                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    પિયરનું ગામ
                                                </label>
                                                <Field
                                                    as="select"
                                                    name="પિયરનું_ગામ"
                                                    className="w-full p-2 border border-gray-300 rounded-md"
                                                    placeholder='પિયરનું ગામ'
                                                >
                                                    <option value="">પિયરનું ગામ</option>
                                                    <option value="જિયરનું ગામ">પિયરનું ગામ</option>
                                                    <option value="પિયરનું ગામ">પિયરનું ગામ</option>
                                                    <option value="જિલ્લો">જિલ્લો</option>
                                                </Field>
                                            </div>
                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    તાલુકો
                                                </label>
                                                <Field
                                                    as="select"
                                                    name="તાલુકો"
                                                    className="w-full p-2 border border-gray-300 rounded-md"
                                                    placeholder='તાલુકો'
                                                >
                                                    <option value="">તાલુકો</option>
                                                    <option value="તાલુકો">તાલુકો</option>
                                                    <option value="તાલુકો">તાલુકો</option>
                                                    <option value="તાલુકો">તાલુકો</option>
                                                </Field>
                                            </div>
                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    જિલ્લો
                                                </label>
                                                <Field
                                                    as="select"
                                                    name="જિલ્લો"
                                                    className="w-full p-2 border border-gray-300 rounded-md"
                                                    placeholder='જિલ્લો'
                                                >
                                                    <option value="">જિલ્લો</option>
                                                    <option value="જિલ્લો">જિલ્લો</option>
                                                    <option value="જિલ્લો">જિલ્લો</option>
                                                    <option value="જિલ્લો">જિલ્લો</option>
                                                </Field>
                                            </div>
                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    મોબાઈલ નંબર<span className='text-red text-18'>*</span>
                                                </label>
                                                <div className='flag_drop input_phone'>
                                                    <PhoneInput
                                                        country={'in'}
                                                        value=""
                                                        onChange={phone => setFieldValue('મોબાઈલ_નંબર', phone)}
                                                        inputClass="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                        placeholder='મોબાઈલ નંબર'
                                                    />
                                                </div>
                                                {/* <ErrorMessage name="મોબાઈલ_નંબર" component="div" className="text-red text-sm mt-1" /> */}
                                            </div>
                                            <div className="w-full px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    રહેઠાણનું હાલનું સરનામું
                                                </label>
                                                <Field
                                                    name="રહેઠાણનુ_હાલનું_સરનામું"
                                                    className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                    placeholder="રહેઠાણનું હાલનું સરનામું"
                                                />
                                                {/* <ErrorMessage name="ટકાવારી" component="div" className="text-red-500 text-sm mt-1" /> */}
                                            </div>
                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    જમીન
                                                </label>
                                                <Field
                                                    name="જમીન"
                                                    className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                    placeholder="જમીન"
                                                />
                                                {/* <ErrorMessage name="જમીન" component="div" className="text-red-500 text-sm mt-1" /> */}
                                            </div>

                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    મકાન(પોતાનું/ભાડાનું)?
                                                </label>
                                                <Field
                                                    name="મકાન "
                                                    className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                    placeholder="મકાન(પોતાનું/ભાડાનું)? "
                                                />
                                                {/* <ErrorMessage name="સભ્યનું_ભણતર" component="div" className="text-red-500 text-sm mt-1" /> */}
                                            </div>
                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    અન્ય
                                                </label>
                                                <Field
                                                    name="અન્ય"
                                                    className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                    placeholder="અન્ય"
                                                />
                                                {/* <ErrorMessage name="મેળવેલ_ગુણ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                            </div>

                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    અન્ય કોઈ ટ્રસ્ટ મારફત સહાય મળે છે કે નહી?
                                                </label>
                                                <Field
                                                    name="અન્ય_કોઈ_ટ્રસ્ટ_મારફત_સહાય"
                                                    className="w-full p-2 border border-gray-300 rounded-md"
                                                    placeholder="અન્ય કોઈ ટ્રસ્ટ મારફત સહાય મળે છે કે નહી?"
                                                />
                                                {/* <ErrorMessage name="મેળવેલ_ગુણ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                            </div>
                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    ટ્રસ્ટ કે મંડળની વિગત
                                                </label>
                                                <Field
                                                    name="ટ્રસ્ટ_કે_મંડળની_વિગત"
                                                    className="w-full p-2 border border-gray-300 rounded-md"
                                                    placeholder="ટ્રસ્ટ કે મંડળની વિગત"
                                                />
                                                {/* <ErrorMessage name="મેળવેલ_ગુણ" component="div" className="text-red-500 text-sm mt-1" /> */}
                                            </div>


                                            <div className="p-3 relative">
                                                <label className="block text-sm font-medium text-text_1 mb-1 cursor-pointer">
                                                    મરણના દાખલાનો ફોટો
                                                </label>
                                                <div className="input w-[300px] h-28 border-dashed border border-primary flex items-center justify-center cursor-pointer">
                                                    <input
                                                        className="absolute w-full h-full inset-0 opacity-0 z-50"
                                                        type="file"
                                                        name="file"
                                                        id="uploader"
                                                        accept="image/*" // Ensure the accept attribute is a comma-separated string
                                                    //   onChange={(event) => {
                                                    //     if (event?.target?.files?.length > 0) {
                                                    //       const files = event?.target?.files;
                                                    //       let isValid = true;
                                                    //       // Check each file type
                                                    //       const file = files[0];
                                                    //       if (!imagearray.includes(file?.type)) {
                                                    //         isValid = false;
                                                    //       }
                                                    //       if (!isValid) {
                                                    //         toast.error("File type is not allowed.");
                                                    //         return;
                                                    //       }
                                                    //       setFieldValue("file", file);
                                                    //       setisFileUpload(true);
                                                    //       setFiles(file);
                                                    //       const reader = new FileReader();
                                                    //       reader.readAsDataURL(file);
                                                    //       reader.onload = (e) => {
                                                    //         setFileName({
                                                    //           name: file?.name,
                                                    //           url: e?.target?.result,
                                                    //         });
                                                    //       };
                                                    //     }
                                                    //   }}
                                                    />
                                                    <span className="icon-export text-18 2xl:text-[20px] text-b1 inline-block"></span>
                                                    <span className="inline-block text-14 2xl:text-16 text-b1">
                                                        Upload
                                                    </span>
                                                </div>{" "}
                                                {/* {fileName && Object.keys(fileName).length > 0 && (
                                                <>
                                                <div className="flex mt-[10px] items-center justify-between max-w-[350px] space-x-2 text-12 md:text-14 xl:text-18 px-2 py-0.5 lg:px-3 lg:py-1.5 bg-b6 rounded-lg mb-1 xs:mb-0">
                                                    <span className="icon-tick-circle text-green"></span>
                                                    <span className="text-b1">{fileName?.name}</span>
                                                    <span
                                                    className="icon-eye text-b1 text-16 md:text-18 xl:text-20 cursor-pointer"
                                                    onClick={() => handleFileView()}
                                                    ></span>
                                                </div>
                                                </>
                                            )} */}
                                            </div>

                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditWidowDaughter;               